import React, { useState, useEffect } from 'react';
import apiClient from '../apis/apiClient';
import './AdminReservations.css';

const AdminReservations = () => {
  const [reservations, setReservations] = useState([]);
  const [filteredReservations, setFilteredReservations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [deletingId, setDeletingId] = useState(null);

  useEffect(() => {
    const fetchReservations = async () => {
      try {
        const response = await apiClient.get('/reservations');
        const data = response.data;
        setReservations(data);
        setFilteredReservations(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReservations();
  }, []);

  useEffect(() => {
    const filtered = reservations.filter(reservation =>
      reservation.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredReservations(filtered);
  }, [searchTerm, reservations]);

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this reservation?')) {
      try {
        setDeletingId(id);
        await apiClient.delete(`/reservations/${id}`);

        // Update the state to remove the deleted reservation
        setReservations(reservations.filter(reservation => reservation.id !== id));
        setFilteredReservations(filteredReservations.filter(reservation => reservation.id !== id));
      } catch (err) {
        setError(err.message);
      } finally {
        setDeletingId(null);
      }
    }
  };

  if (loading) {
    return <div className="loading">Loading reservations...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  return (
    <div className="container">
      <h2 className="header">Reservierungsmanagement</h2>

      <div className="search-container">
        <input
          type="text"
          placeholder="Suche nach Namen..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <span className="search-count">
          Zeigt {filteredReservations.length} of {reservations.length} Reservierungen
        </span>
      </div>

      <div className="table-container">
        <table className="reservation-table">
          <thead>
            <tr className="header-row">
              <th>AUSWEIS</th>
              <th>Name</th>
              <th>E-Mail</th>
              <th>Datum</th>
              <th>Zeit</th>
              <th>Gäste</th>
              <th>Nachricht</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredReservations.length > 0 ? (
              filteredReservations.map((reservation) => (
                <tr key={reservation.id} className="table-row">
                  <td>{reservation.id}</td>
                  <td>{reservation.name}</td>
                  <td>{reservation.email}</td>
                  <td>{reservation.date}</td>
                  <td>{reservation.time}</td>
                  <td>{reservation.guests}</td>
                  <td>{reservation.message || 'No message'}</td>
                  <td>
                    <button
                      onClick={() => handleDelete(reservation.id)}
                      disabled={deletingId === reservation.id}
                      className="delete-button"
                    >
                      {deletingId === reservation.id ? 'Deleting...' : 'Delete'}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="no-results">
                  No reservations found matching your search
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminReservations;